import clsx from 'clsx';
import { useCallback, useEffect, useState } from 'react';
import React from 'react';
import { createPortal } from 'react-dom';

import { Provider } from './provider';

const mapNumberToRange = (
	num,
	in_min,
	in_max,
	out_min,
	out_max,
) => {
	return ((num - in_min) * (out_max - out_min)) / (in_max - in_min) + out_min;
};

const SnackMessageProvider = ({ children }) => {
	const [queue, setQueue] = useState([]);

	const pushSnackMessage = useCallback(
		(message, variant) =>
			setQueue(old =>
				[
					...old,
					{
						message,
						variant,
					},
				].slice(0, 10),
			),
		[],
	);

	const clearSnackMessage = useCallback(() => {
		setQueue([]);
	}, []);

	useEffect(() => {
		if (queue.length > 0) {
			const timer = setTimeout(
				() => setQueue(old => old.slice(1)),
				mapNumberToRange(queue.length, 1, 10, 5000, 1000),
			);

			return () => clearTimeout(timer);
		}
	}, [queue]);

	return (
		<Provider value={{ push: pushSnackMessage, clear: clearSnackMessage }}>
			{children}

			{queue.length > 0 &&
                createPortal(
                	<div
                		style={{ zIndex: 9999 }}
                		className="fixed bottom-[5vh] inset-x-0 w-full flex justify-center px-4 pointer-events-none"
                		role="alert"
                	>
                		<span
                			style={{ fontSize: '1rem', borderRadius: 25 }}
                			className={clsx(
                				'border-2 bg-light px-10 py-2 text-center pointer-events-auto break-words max-w-full shadow-md',
                				queue[0].variant ? `border-${queue[0].variant}` : 'border-secondary',
                			)}
                		>
                			{queue[0].message}
                		</span>
                	</div>,
                	document.body
                )}
		</Provider>
	);
};

export default SnackMessageProvider;